
<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span class="headline pl-0">{{ gameInstance.name }}</span>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0" v-if="gameInstance.portals && gameInstance.portals.length > 0">
        <div v-for="portal in gameInstance.portals" v-bind:key="portal.uid">
            <span class="portal caption">{{portal.name}}</span>
        </div>
      </v-col>
      <v-col v-if="gameInstance.checkInAt" cols="12">
        <span class>
          <v-icon small color="white"
          >mdi-calender</v-icon
          >&nbsp;<span class="body-2">Check-In: {{format(new Date(gameInstance.checkInAt), 'dd.MM.yyyy HH:mm')}}</span>
        </span>
      </v-col>
      <v-col v-if="gameInstance.startsAt" cols="12">
        <span class>
          <v-icon small color="white"
          >mdi-calender</v-icon
          >&nbsp;<span class="body-2">Start: {{format(new Date(gameInstance.startsAt), 'dd.MM.yyyy HH:mm')}}</span>
        </span>
      </v-col>
      <v-col v-if="gameInstance.officialCompetition" cols="12">
        <span class>
          <v-icon small style="color: #3f9df5; caret-color: #3f9df5"
            >mdi-check-decagram</v-icon
          >&nbsp;<span class="body-2">{{$t('gameInstanceInfo.is-official')}}</span>
        </span>
      </v-col>
      <v-col cols="12">
        <v-icon left color="primary">{{ platform.mdi_icon }}</v-icon>
        <v-icon left>{{ game.mdi_icon }}</v-icon>
        <span class="text--secondary">{{ game.name }}</span>
        <span class="ml-1" style="white-space:pre;">
          <v-icon left>{{ getGameTypeIcon(gameInstance.type) }}</v-icon>
          <span class="text--secondary">{{ getGameTypeLabel(gameInstance.type) }}</span>
        </span>
      </v-col>
      <v-col cols="12" v-if="gameInstance.premiumOnly">
        <span class="overline">{{$t('gameInstanceInfo.premium-only')}}</span>
      </v-col>
      <v-col cols="12" v-if="gameInstance.description">
        <span class="body-2 notice">{{$t('gameInstanceInfo.read-rules-notice')}}</span>
      </v-col>
      <v-col cols="12">
        <game-info
          :game="gameInstance"
          class="ma-0 pa-0"
          :showGameState="false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gameTypeMixin from "@/mixins/gameTypeMixin";
import GameInfo from "@/widgets/GameInfo";
import {format} from 'date-fns'

export default {
  name: "GameInstanceInfo",
  mixins: [gameTypeMixin],
  components: { GameInfo },
  props: {
    gameInstance: {
      type: Object,
      required: true,
    },
    platform: {
      type: Object,
      required: true,
    },
    game: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    format: format,
  },
};
</script>
